module.exports = new __parcel__URL__("dams2.9f4ce0a4.jpg").toString();